import { useMutation, useQueryClient } from '@tanstack/react-query';

import { raiseEvent } from '@cast/analytics';
import { parseApiError, getApiClient } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { useOrganizations } from '@cast/shared-organization-context-data-access';

import { getReportingTrialStatusQueryKey } from './useReportingTrialStatusQuery';

export const useStartReportingTrialMutation = () => {
  const queryClient = useQueryClient();
  const { currentOrganization } = useOrganizations();

  return useMutation({
    mutationFn: () =>
      getApiClient().costReport.startReportingMonetizationTrial({
        body: {},
      }),
    onSuccess: () => {
      // TODO(API): include trial_id from start-trial / status response when BE returns it
      raiseEvent({
        title: 'reporting_trial_started',
        type: 'reporting_monetization',
        source: 'start_trial_mutation',
      });
      queryClient.invalidateQueries({
        queryKey: getReportingTrialStatusQueryKey(currentOrganization?.id),
      });
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
